<!-- 油卡操作 -->
<template>
  <div>
    <el-drawer :close-on-press-escape="true" :visible.sync="dataActionBox.showStatus" :with-header="false" append-to-body custom-class="drawer_box" :direction="dataActionBox.openMode" size="50%">
      <div class="demo-drawer__content data_action_form">
        <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="formDataList">
          <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="formDataList" @tabs="(val)=>{showTabs=val}" @tabHeight="(val)=>{mxHeight=val}">
            <template slot="tabs" slot-scope="scope">
              <div v-if="scope.index==0" class="table_content_box">
                <el-form class="baseForm"  label-width="150px" size="mini" :show-message="false" :model="sendDataInfo" ref="sendDataInfo">
                  <el-row>
                    <el-form-item :label="formOneValue.showField" v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" :key="formOneKey" :prop="formOneValue.entityField" v-if="formOneValue.isShow==1" :rules="formOneValue.isRequired == 1? [{required:  formOneValue.isChange == 1, trigger: ['blur', 'change']}] : []">

                      <!-- 开卡日期 -->
                      <el-date-picker :disabled="formOneValue.isChange == 0" v-if="formOneValue.entityField == 'cardDate'" v-model="sendDataInfo[formOneValue.entityField]" type="date" format="yyyy 年 MM 月 dd 日" value-format="timestamp"></el-date-picker>
                      <!-- 油卡类型 -->
                      <el-select :disabled="formOneValue.isChange == 0" v-else-if="formOneValue.entityField == 'cardType'" v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择类型">
                        <el-option v-for="item in oilCardTypeList" :key="item.diId" :label="item.diName" :value="item.diId">
                        </el-option>
                      </el-select>
                      <!-- 油卡状态 -->
                      <el-radio-group :disabled="formOneValue.isChange == 0" v-else-if="formOneValue.entityField == 'cardState'" v-model="sendDataInfo[formOneValue.entityField]">
                        <el-radio-button label="0">停用</el-radio-button>
                        <el-radio-button label="1">启用</el-radio-button>
                      </el-radio-group>

                      <el-input :disabled="formOneValue.isChange==1?false:true" v-else v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>
                    </el-form-item>
                  </el-row>
                </el-form>
              </div>
            </template>
          </v-tabs>
        </el-card>
        <div class="foots">
          <el-button type="primary" @click="initActionBox">关闭</el-button>
          <el-button type="primary" @click="sendDataAction()" v-if="dataActionBox.actionType==0">保存</el-button>
          <el-button type="primary" @click="sendDataAction()" v-if="dataActionBox.actionType==1">保存</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: "oilCardManageAction",
  props: [],
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      dataActionBox: {
        showStatus: false,
        openMode: "ltr",
        boxTitle: "新增" || "编辑",
        actionType: 0, // 0新增，1修改
      },
      showTabs: "",
      formDataList: [],
      sendDataInfo: {
        "cardBalance": 0,
        "cardCode": "",
        "cardDate": 0,
        "cardReserves1": "",
        "cardReserves2": "",
        "cardReserves3": "",
        "cardReserves4": "",
        "cardReserves5": "",
        "cardReserves6": "",
        "cardState": 1,
        "cardType": 0,
        "createTime": 0,
        "creater": 0,
        "updateTime": 0
      },
      oilCardTypeList: [], //油卡类型

    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
  },
  //方法集合
  methods: {
    //保存
    async sendDataAction() {
      let flag = false
      this.$refs['sendDataInfo'].validate((valid) => {
        if (valid) { } else {
          this.$message({
            message: '请完善油卡表单的必填信息',
            type: 'error'
          })
          flag = true
          return false;
        }
      })
      if (flag) return false;
      if (this.sendDataInfo.cardBalance <= 0) {
        this.$message({
          message: '请填写正确的油卡可用余额',
          type: 'error'
        })
        return false;
      }

      // console.log('zeng', this.sendDataInfo);
      let sendData = JSON.parse(JSON.stringify(this.sendDataInfo))
      let responseData

      if (this.dataActionBox.actionType == 0) {
        responseData = await this.$http.gascardAdd(sendData)
      } else {
        responseData = await this.$http.gascardUpdate(sendData)
      }
      if (responseData && responseData.status == 200) {
        this.$message({
          message: this.dataActionBox.boxTitle + '成功',
          type: 'success'
        })
        this.$parent.getDataList()
        this.init()
        this.$refs['sendDataInfo'].resetFields()
        this.dataActionBox.showStatus = false

      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        })
      }
    },

    //取消新增
    initActionBox() {
      if (this.dataActionBox.actionType == 5) return this.dataActionBox.showStatus = false
      this.dataActionBox.showStatus = false
      this.init();
      this.$refs['sendDataInfo'].resetFields();
    },

    //初始化
    init() {
      for (const key in this.sendDataInfo) {
        if (key == 'cardDate' || key == 'createTime' || key == 'updateTime') {
          this.sendDataInfo[key] = this.$moment().valueOf()
        } else {
          this.sendDataInfo[key] = ''
        }
      }
      this.sendDataInfo.cardState = 1
      this.sendDataInfo.cardBalance = 0
      this.dataActionBox.actionType = 0
      this.dataActionBox.boxTitle = ''
    },

    //父级传入 获取列表
    openBox(cate, formData, oldData = "") {
      // console.log('oldData', oldData);
      this.formDataList = formData;
      this.init();
      this.dataActionBox.showStatus = true
      this.dataActionBox.actionType = cate;
      this.showTabs = formData[0].jciName;
      if (cate == 0) {
        this.dataActionBox.boxTitle = "新增油卡";
        this.dataActionBox.openMode = "ltr";
      } else {
        this.dataActionBox.boxTitle = "修改油卡";
        this.dataActionBox.openMode = "ltr";
        this.sendDataInfo = JSON.parse(JSON.stringify(oldData))
        this.sendDataInfo.cardType = Number(this.sendDataInfo.cardType)
      }
    },
    //获取油卡类型
    async getOilType() {
      let responseData = await this.$http.getCateDictionariesData({
        ids: [36],
      })
      if (responseData.status == 200) {
        this.oilCardTypeList = responseData.result
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        })
      }
    },


  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getOilType()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.baseForm .el-row {
  display: flex;
  flex-wrap: wrap;
}
</style>
